import styled from 'styled-components'

export const SettingsPageContainer = styled.div`
  iframe {
    width: 0;
    height: 0;
    border: none;
    position: absolute;
  }
`
